import { AccrediblePaginationComponentModule } from '@accredible-frontend-v2/new-components/pagination';
import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DirectoryFilteringComponent } from '../directory-filtering/directory-filtering.component';
import { DirectorySortingComponent } from '../directory-sorting/directory-sorting.component';
import { DirectoryStoreService } from '../services/directory-store.service';
import {
  DirectoryToolbarState,
  DirectoryToolbarStateService,
} from '../services/directory-toolbar-state.service';
import { DirectoryToolbarUrlSyncService } from '../services/directory-toolbar-url-sync.service';

@Component({
  standalone: true,
  selector: 'dod-directory-toolbar',
  templateUrl: `./directory-toolbar.component.html`,
  styleUrls: ['./directory-toolbar.component.scss'],
  imports: [
    AccrediblePaginationComponentModule,
    DirectorySortingComponent,
    DirectoryFilteringComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryToolbarComponent {
  private readonly _store = inject(DirectoryStoreService);
  private readonly _stateService = inject(DirectoryToolbarStateService);
  private readonly _urlSyncService = inject(DirectoryToolbarUrlSyncService);

  state = toSignal(this._stateService.urlState$, {
    initialValue: { search: '' } as DirectoryToolbarState,
  });

  get search(): string {
    return this.state().search;
  }

  get sorting(): number {
    return this.state().sorting;
  }

  get categories(): string[] {
    return this.state().skill_categories;
  }

  // TODO: cannot switch to viewChild signal due to this ng-mocks bug: https://github.com/help-me-mom/ng-mocks/issues/8634
  @ViewChild(DirectoryFilteringComponent)
  private readonly _searchFilter: DirectoryFilteringComponent;

  currentRegionMetadata = this._store.currentRegionMetadata;

  onSortingChanged(event: { index: number; skip: boolean }): void {
    if (!event.skip) {
      this.emitChange({ sorting: event.index });
    }
  }

  emitChange(partial: Partial<DirectoryToolbarState>): void {
    this._stateService.update(partial);
  }

  clearFilters(): void {
    this._searchFilter.clear();
  }

  onPageChange($event: number): void {
    this._stateService.updatePage($event);
  }
}
